"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboard = void 0;
const React = __importStar(require("react"));
const AdminMGTProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/AdminMGTProvider");
const react_1 = require("react");
const DashboardRefreshComponent_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/dashboard/DashboardRefreshComponent");
const antd_1 = require("antd");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const AdminDashboardStats_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/dashboard/AdminDashboardStats");
const AdminDashboardProjects_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/dashboard/AdminDashboardProjects");
const AdminDashboard = () => {
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    (0, react_1.useEffect)(() => {
        adminMGTContext.getInformation();
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Usergeek Admin Panel", extra: React.createElement(DashboardRefreshComponent_1.DashboardRefreshComponent, null) }),
        React.createElement(PageContent_1.PageContent, null,
            React.createElement(AdminDashboardStats_1.AdminDashboardStats, null),
            React.createElement(AdminDashboardProjects_1.AdminDashboardProjects, null)));
};
exports.AdminDashboard = AdminDashboard;
